var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('events-chart'),_c('events-distribution',{staticClass:"mt-4"}),_c('events-products',{staticClass:"mt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }